"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormRow = exports.Form = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
exports.Form = styled_components_1.default.div `
  display: grid;
  row-gap: ${style_1.default.Layout.Spacing.Base};
`;
exports.FormRow = styled_components_1.default.div `
  align-items: center;
  column-gap: ${style_1.default.Layout.Spacing.Base};
  display: flex;
  justify-content: space-between;
`;
